import FlashMessage from './FlashMessage'
import useFlashMessage from './hooks/useFlashMessage'
import flashMessageReducer from './reducers/flashMessageReducer'

export { useFlashMessage, flashMessageReducer }
export default FlashMessage
